import { mergeSx } from '@/shared/utils/merge-sx.util';
import palette from '@/shared/styles/themePalette';
import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';

type TooltipIconProps = IconButtonProps & {
  href?: string;
  component?: React.ElementType;
};

export const TooltipIcon = React.forwardRef(
  (
    { children, component = 'span', sx, ...props }: TooltipIconProps,
    ref: React.Ref<HTMLButtonElement>,
  ) => {
    return (
      <IconButton ref={ref} component={component} sx={mergeSx(styles, sx)} {...props}>
        {children}
      </IconButton>
    );
  },
);

const styles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: palette.grey[800],
  },
  '& svg': {
    color: palette.primary.main,
  },
};
